/****************************************************
 * Module Name:  releaseStoneModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg';
import CheckIcon from '@mui/icons-material/Check';

const StoneAvailableModal = ({
  show,
  setShow,
  handleValidation,
  handleSave,
  stoneIds,
  loading,
}) => {
  const [remark, setRemark] = useState("");
  const [showError, setShowError] = useState(false);

  const saveHandler = () => {
    let data = {
      userid: Constants.loggedInUser.id,
      remark: remark,
      stones: stoneIds,
    };
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          handleSave(data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <CommonSnackbar
        show={showError}
        message={
          <Box>
            Stone Available validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Mark stones as available
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Form.Label className="mt-2">Remark</Form.Label>
            <TextField
              id="outlined-multiline-static"
              label="Remark"
              multiline
              fullWidth
              rows={4}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            loading={loading}
            loadingPosition="start"
            variant="contained"
            onClick={saveHandler}
            type="Submit"
            color="success"
            startIcon={<CheckIcon size="large" />}
            sx={{ mr: 3 }}
          >
            Available
          </LoadingButton>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StoneAvailableModal;
